module.exports = __webpack_public_path__ + "static/media/feature-invite2.0aa2ccb9.png";